module.exports = __webpack_public_path__ + "static/ms-net-15e457d2aac5d7b32f98c2bdfe8ade49.svg";